import React, { Component } from 'react';
import {APP_VERSION} from '../constants'
import {Link} from 'react-router-dom'
import '../assets/css/home.style.css';
import {  FaReact, FaBell, FaCoins, FaFileAlt, FaCheck, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';


class HOMEWrapper extends Component {

  render () {


    if(window.location.hostname === "cms.goodsbill.com") {
      return <CMSHome />
    }
    else {
        return <Home />
    }


  }

}

class CMSHome extends Component {
  render() {
    return <div>

    <div id="front-main" className="text-white withbg2" >
      <div className="front-main-mask dark"></div>
    <div className="container  " style={{height:'100vh'}}>
        <div className="row text-center" >
          <div className="col-sm-12" >

          <h2 className="" style={{marginTop:50,marginBottom:40}}>GoodsBill <span style={{fontSize:18}}>CMS</span></h2>

          <ul className="list-unstyled list-inline">
          <li>
          <Link to="/signup" className="btn btn-success btn-lg hbtn">Get Started</Link>
          </li>
          <li>
          <Link to="/login" className="btn btn-outline btn-lg hbtn">Sign In</Link>
          </li>


          </ul>
          </div>

        </div>
    </div>
    </div>


    </div>
  }
}

class Home extends Component {

  render() {



    return (
      <div>

      <div id="front-main" className="text-white withbg" >
        <div className="front-main-mask"></div>
      <div className="container pbig ">
          <div className="row">
            <div className="col-sm-12 text-center">
            <h1 className="h1" style={{marginTop:2}}><span>GoodsBill</span></h1>
            <h2 className="">Generate Invoices With Blazing Speed</h2>
            <div className="psmall">
            <Link to="/signup" className="btn btn-success btn-lg hbtn">Get Started</Link>

            </div>
            <div className="">
            <Link to="/login" className="btn btn-outline hbtn">Sign In</Link>
            </div>
            </div>

          </div>
      </div>
      </div>

      <section className="pbig">
      <div className="container">
            <div className="row">
              <div className="col-sm-4 text-center">
              <div className="pmedium">
                  <div className="row">
                  <div className="col-sm-10 col-sm-offset-1">
                  <h3 className='psmall'><FaFileAlt /></h3>
                  <h3>Faster Invoicing </h3>
                  <div className="psmall ">
                    Goodsbill has chosen tech stack to generate invoices at amazing speed.
                  </div>
                  </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 text-center">
              <div className="pmedium">
              <div className="row">
              <div className="col-sm-10 col-sm-offset-1">
              <h3 className='psmall'><FaCoins/></h3>
                <h3>Affordable Pricing</h3>
                <div className="psmall">
                  Simple pricing for small & medium enterprises, no dilema at all.
                </div>
                </div>
                </div>
                </div>
              </div>
              <div className="col-sm-4 text-center">
              <div className="pmedium">
              <div className="row">
              <div className="col-sm-10 col-sm-offset-1">
                <h3 className='psmall'><FaBell/></h3>
                <h3>Reliable Support</h3>
                <div className="psmall">
                  With experts in dev team, 90% of issues are solved in less than 24hrs.
                </div>
                </div>
                </div>
                </div>
              </div>
            </div>

      </div>
      </section>

      <section className="background-secondary hidden" >

          <div className="container">

          <div className="row">
            <div className="col-xs-12">
              <h3 className="text-center pmedium">Pricing </h3>
            </div>
          </div>

              <div className="row">


                <div className=" col-sm-4 col-sm-offset-4">
                    <div className="panel panel-default">
                        <div className="panel-body">
                        <div className="panel-body">

                        <div className="psmall text-center">
                          <small>&#8377;</small> <strong><span style={{fontSize:30}}>4000</span></strong>
                          <small> per year</small>
                        </div>

                        <hr />

                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span ><span className="mltiny">Unlimited Invoices</span>
                        </div>
                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span><span className="mltiny">Email Support</span>
                        </div>

                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span><span className="mltiny">Phone Support</span>
                        </div>

                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span><span className="mltiny">Custom Invoice Template</span>
                        </div>

                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span><span className="mltiny">Invoice History</span>
                        </div>
                        <div className="ptiny">
                            <span><FaCheckCircle className="text-primary small" /> </span><span className="mltiny">Multi User Support</span>
                        </div>

                        </div>

                        <div className="psmall">
                        <Link to="/signup" className="btn btn-primary btn-block" >
                         GET STARTED
                        </Link>
                        </div>

                        </div>
                    </div>
                </div>

              </div>


          </div>
      </section>

      <section>
      <div className="container">
            <div className="row">
              <div className="col-md-8 col-sm-10 col-sm-offset-1 col-md-offset-2">
                  <h3 className="text-center pmedium">Customer’s Feedback</h3>
                  <blockquote>
                  <p>Excellent support from goodsbill team. I am 100% satisfied with the features provided.
                  </p>
                  <small>
                      Chandra Generals - Nellore.
                  </small>
                  </blockquote>

                  <blockquote>
                  <p>So simple to generate invoice, new custom template designed for my business is amazing,
                  thanks to goodsbill
                  </p>
                  <small>
                      Paluri Enterprises - Naidupet.
                  </small>
                  </blockquote>

              </div>
            </div>
          </div>
      </section>

      <section className="background-secondary pbig" style={{backgroundColor:"#000C2D"}} >
      <div className="container text-center text-muted">
        <strong className="pmedium">UI powered by facebook’s <i className="">reactjs</i> <FaReact className="text-info" /> and APIs are responded by <i>django</i>.</strong>
       <div>
        <strong>Proudly made in Naidupet, India.</strong>
        </div>
        <div className="small">
          version: {APP_VERSION}
        </div>
      </div>

      <div className="container" >
        <img src="/static/images/le-logo-wide.png" className="center-block img-responsive" style={{maxWidth:150}} />

      </div>

      </section>
      <div style={{backgroundColor:"#000C2D"}} className="pbig hidden ">
        <div className="container">
        <div className="row">
        <div className="col-sm-4 text-muted col-sm-offset-4 text-right">

        </div>
        <div className="col-sm-4 text-muted">
        <ul className="list-unstyled hidden">
          <li>Multiple Invoice Formats</li>
          <li>Day Report</li>
          <li>GSTR1 and GSTR3B Reports</li>
        </ul>
        </div>
        </div>
        </div>
      </div>
      </div>
    )
  }
}

export default HOMEWrapper



// WEBPACK FOOTER //
// ./src/components/home.js